/**
 * @generated SignedSource<<cd3f50e31921b694671e56919f44c13e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceRoutineOccasionListHeader_RoutineWorkspaceOccasion$data = {
  readonly id: string;
  readonly issueCount: number;
  readonly registeredIssueCount: number;
  readonly storesCompletedCount: number;
  readonly storesCount: number;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceRoutineOccasionSelectButton_workspaceRoutineOccasion">;
  readonly " $fragmentType": "WorkspaceRoutineOccasionListHeader_RoutineWorkspaceOccasion";
};
export type WorkspaceRoutineOccasionListHeader_RoutineWorkspaceOccasion$key = {
  readonly " $data"?: WorkspaceRoutineOccasionListHeader_RoutineWorkspaceOccasion$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceRoutineOccasionListHeader_RoutineWorkspaceOccasion">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkspaceRoutineOccasionListHeader_RoutineWorkspaceOccasion",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "storesCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "storesCompletedCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "issueCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "registeredIssueCount",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WorkspaceRoutineOccasionSelectButton_workspaceRoutineOccasion"
    }
  ],
  "type": "RoutineWorkspaceOccasion",
  "abstractKey": null
};

(node as any).hash = "bc0aefca421d2a469e4257aa2822ce59";

export default node;
